module.exports = __webpack_public_path__ + "static/media/power2.76c0860f.svg";